module.exports = __webpack_public_path__ + "img/integration.a2da5e68.svg";